import {IdCodeNameModel} from "common-shared";

export class ActivityStreamItem extends IdCodeNameModel {
  public ModifiedDate: Date;
  public ModifiedBy: string;
  public Type: number;
  public Url: string;
}
